export default function reducer(
  state = {
    createCampaign: '',
  },
  action
) {
  switch (action.type) {
    case 'CREATE_CAMPAIGN_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'CREATE_CAMPAIGN_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        createCampaign: action.payload,
      };
    }
    case 'CREATE_CAMPAIGN_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        createCampaign: action.payload,
      };
    }
    case 'CREATE_CAMPAIGN_RESET': {
      return {
        ...state,
        changingStatus: 'reset',
        createCampaign: '',
      };
    }
    default: {
      return state;
    }
  }
}
